

























import Vue from 'vue';
import A11yHelper from '@/helpers/A11yHelper';
import { ILanguageSelectionComponent } from '@/common/interfaces/header.interface';

export default Vue.extend({
  name: `LanguageSelection`,
  data(): ILanguageSelectionComponent {
    return {
      showMenu: false,
    };
  },
  props: {
    language: {
      required: true,
      type: String,
    },
    languages: {
      required: true,
      type: Array as () => string[],
    },
  },
  methods: {
    focusOut(e: FocusEvent | null): void {
      this.showMenu = A11yHelper.isFocusWithinCurrentGroup(e);
    },
  },
});
